/* eslint-disable */
require('./ar')
require('./backgrounds')
require('./dmds-logo')
require('./guide-graphics')
require('./hospital-logo-white-bg')
require('./icons')
require('./loaders')
require('./locales')
require('./logo')
require('./map-navigation')
require('./mobile-map-logo-granby')
require('./mobilis-logo')
require('./mobilkarta_popup')
require('./navigation')
require('./player')
require('./posters')
require('./qr-bg')
require('./qr-support')
require('./qr')
require('./scan-qr-granby')
require('./scan-qr-hand')
require('./services')
require('./storo-storsenter-logo')
